module.exports = __webpack_public_path__ + "img/pause.5d7db650.png";